module.exports = __webpack_public_path__ + "static/media/Inter-ThinItalic.7a27099d.woff";